module.exports = __webpack_public_path__ + "img/order-message-free-status.85b616ee.svg";